import { computed, Injectable, signal } from '@angular/core';

/**
 * Loader locale basato su signal, da usare dentro una porzione di pagina.
 * Va abbinato a <app-local-loader> dentro un wrapper `position: relative`.
 */
@Injectable()
export class LocalLoaderService {
    private _requestCount = signal<number>(0);
    private _message = signal<string | null>(null);

    public isLoading = computed(() => this._requestCount() > 0);
    public message = computed(() => this._message());

    show(msg: string | null = null) {
        this._message.set(msg);
        this._requestCount.update(count => count + 1);
    }

    hide() {
        this._requestCount.update(count => {
            const newCount = Math.max(0, count - 1);
            if (newCount === 0) this._message.set(null);
            return newCount;
        });
    }

    forceHide() {
        this._requestCount.set(0);
        this._message.set(null);
    }
}
